import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=61a2351a"
import script from "./category-list.vue?vue&type=script&lang=js"
export * from "./category-list.vue?vue&type=script&lang=js"
import style0 from "./category-list.vue?vue&type=style&index=0&id=61a2351a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports